export default __webpack_public_path__ + "static/media/skate-banner.80d13f0e.jpeg";